import productionEnum from '../../productionEnum.macro'

export const InputKeyDownArrowDown = productionEnum(
  '__input_keydown_arrow_down__',
)
export const InputKeyDownArrowUp = productionEnum('__input_keydown_arrow_up__')
export const InputKeyDownEscape = productionEnum('__input_keydown_escape__')
export const InputKeyDownHome = productionEnum('__input_keydown_home__')
export const InputKeyDownEnd = productionEnum('__input_keydown_end__')
export const InputKeyDownEnter = productionEnum('__input_keydown_enter__')
export const InputChange = productionEnum('__input_change__')
export const InputBlur = productionEnum('__input_blur__')
export const MenuMouseLeave = productionEnum('__menu_mouse_leave__')
export const ItemMouseMove = productionEnum('__item_mouse_move__')
export const ItemClick = productionEnum('__item_click__')
export const ToggleButtonClick = productionEnum('__togglebutton_click__')
export const FunctionToggleMenu = productionEnum('__function_toggle_menu__')
export const FunctionOpenMenu = productionEnum('__function_open_menu__')
export const FunctionCloseMenu = productionEnum('__function_close_menu__')
export const FunctionSetHighlightedIndex = productionEnum(
  '__function_set_highlighted_index__',
)
export const FunctionSelectItem = productionEnum('__function_select_item__')
export const FunctionSetInputValue = productionEnum(
  '__function_set_input_value__',
)
export const FunctionReset = productionEnum('__function_reset__')
